import { CloudOff } from '../icons';

/**
 * Persistent (non-transient) offline indicator, shared shape across screens
 * that surface sync state (today-view.md SS3, objective-detail.md SS2).
 * Not `pattern.cornerToast` — this is the "small persistent chip" variant
 * called out explicitly as different from the transient toast pattern.
 */
export function OfflineChip() {
  return (
    <div
      role="status"
      style={{
        display: 'flex',
        alignItems: 'center',
        gap: 'var(--space-2)',
        fontSize: 'var(--type-caption-size)',
        lineHeight: 'var(--type-caption-line)',
        color: 'var(--text-secondary)',
        margin: '0 var(--layout-page-margin-phone) var(--space-3)',
      }}
    >
      <CloudOff size={14} strokeWidth={2} aria-hidden="true" />
      Saved on this device — will sync.
    </div>
  );
}
